module.exports = __webpack_public_path__ + "media/images/badges/biodiversity-100-da4c2e36df038ccefa9e16c11904ec13.svg";